import {useAppSelector} from "../../../redux/hooks";
import {mySongsFiltersStore} from "../../../pages/songs-router/modules/my-songs-filters-store/mySongsFiltersStore";

export interface IFilterDifficultyCategoriesLogic {
  difficultyCategoryIds: number[];
}

export const useFilterDifficultyCategoriesLogic = (): IFilterDifficultyCategoriesLogic => {
  return {difficultyCategoryIds: useAppSelector(mySongsFiltersStore.getDifficultyCategoryIds)};
}
